export default __webpack_public_path__ + "static/media/t.230a61a9.mp4";